var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4,
    y: -4,
    width: 32,
    height: 32
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_2226_8555_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(-180 24 24)",
    fill: "#E74860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17L14.6464 12.3536C14.8417 12.1583 14.8417 11.8417 14.6464 11.6464L10 7",
    stroke: "white",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2226_8555_clip_path",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(-180 24 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBack);
export default __webpack_public_path__ + "static/media/RightBack.194d4ca9b1d1d8c1146175f171fcced1.svg";
export { ForwardRef as ReactComponent };